import { NgModule } from '@angular/core';
import { AppComponent } from '@app/app.component';
import { ButtonModule } from 'primeng/button';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { RwiqhaTheme } from '@app/primeng-theming';
import { FormsModule } from '@angular/forms';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { LayoutModule } from '@layout/layout.module';
import { AppRoutes } from '@app/app.routes';
import { HttpInterceptorInterceptor } from '@interceptors/http-interceptor';
import { EmptyPageComponent } from '@shared/empty-page/empty-page.component';
import { PipesModule } from '@pipes/pipes.module';
import { PageTitleService } from './services/page-title.service';

function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

const I18N_CONFIG = {
    defaultLanguage: 'ar',
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }


@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        FormsModule,
        ButtonModule,
        BrowserModule,
        AppRoutes,
        HttpClientModule,
        TranslateModule.forRoot(I18N_CONFIG),
        BrowserAnimationsModule,
        LayoutModule,
        PipesModule
    ],
    providers: [
        PageTitleService,
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: RwiqhaTheme ,options:{darkModeSelector:false}} }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorInterceptor,
            multi: true
          },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }